<template>
  <div class="podcast-section-seo">
    <div v-if="loading" class="text-gray-600">
      Loading...
    </div>

    <div v-else>
      <FormSection class="col-1/2">
        <FormRow
          label="Titolo"
          legend="(massimo 50 caratteri)"
          for-id="seo-title"
          name="Titolo"
          rules="max:50"
        >
          <v-input
            type="text"
            v-model="modelData.title"
            id="seo-title"
            name="seo-title"
          />
        </FormRow>

        <FormRow
          label="Descrizione"
          legend="(massimo 250 caratteri)"
          for-id="seo-description"
          name="Descrizione"
          rules="max:250"
        >
          <v-textarea v-model="modelData.description" id="seo-description" />
        </FormRow>

        <FormRow
          label="Immagine di anteprima"
          legend="(dimensioni consigliate 1200x630)"
          for-id="seo-image"
        >
          <v-image-input
            v-model="modelData.imageUrl"
            id="seo-image"
            :podcast-id="id"
            :imageWidth="1200"
            :imageHeight="630"
          />
        </FormRow>
      </FormSection>
    </div>
  </div>
</template>

<script>
import PodcastSectionBase from './PodcastSectionBase'
import GET_PODCAST_SEO from '@/graphql/GetPodcastSeo.gql'
import UPDATE_PODCAST_SEO from '@/graphql/UpdatePodcastSeo.gql'

export default {
  extends: PodcastSectionBase,

  section: {
    query() {
      return {
        query: GET_PODCAST_SEO,
        variables: { podcastId: this.id },
      }
    },
    mutation() {
      return this.$apollo.mutate({
        mutation: UPDATE_PODCAST_SEO,
        variables: {
          id: this.id,
          seo: this.modelData,
        },
      })
    },
    model: {
      title: null,
      description: null,
      imageUrl: null,
    },
    saveModel: data => ({ ...(data.findPodcastByID.settings || {}).seo }),
  },
}
</script>

<style lang="scss" scoped></style>
